import { SectionHead, FadeUp } from "./Reveal";

const CREDENTIALS = [
  "Registered Massage Therapist — 2200 hrs",
  "Fascia Stretch Massage",
  "Chair Massage — a favourite for events",
  "Myofascial Release",
  "Thai Massage",
  "Reflexology — where it all started, 2007",
  "Reiki",
  "Fitness & Nutrition Certified",
  "Joga Training",
  "Face & Buccal Certification",
  "Certified Spiritual Coach",
];

export const About = () => (
  <section id="about" className="relative py-24 lg:py-32" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-5 lg:sticky lg:top-24">
        <FadeUp>
          <div className="clip-notch relative overflow-hidden border border-white/10" data-testid="about-portrait">
            <img src="/images/ariane-about.jpg" alt="Ariane Kamba — portrait" loading="lazy"
              className="h-[30rem] lg:h-[36rem] w-full object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" aria-hidden="true" />
          </div>
        </FadeUp>
        <FadeUp delay={0.08}>
          <div className="clip-notch relative overflow-hidden border border-white/10 mt-5" data-testid="about-portrait-2">
            <img src="/images/banner.png" alt="Ariane Kamba — Elite Therapeutics, Wellness in Motion" loading="lazy"
              className="h-56 sm:h-64 w-full object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" aria-hidden="true" />
          </div>
        </FadeUp>
        <FadeUp delay={0.1}>
          <div className="mt-6 grid grid-cols-2 gap-3">
            <div className="rounded-xl border border-gold/25 bg-gold/5 p-4" data-testid="about-badge-nhpc">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">Alberta</p>
              <p className="mt-1 text-sm text-ivory">NHPC Registered</p>
            </div>
            <div className="rounded-xl border border-gold/25 bg-gold/5 p-4" data-testid="about-badge-fqm">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">Montreal</p>
              <p className="mt-1 text-sm text-ivory">FQM Registered</p>
            </div>
          </div>
        </FadeUp>
      </div>

      <div className="lg:col-span-7">
        <SectionHead
          eyebrow="About"
          title={<>Ariane Kamba, <em className="italic text-gold">M.B.S. Therapist</em></>}
        />
        <FadeUp>
          <p className="mt-5 font-serif italic text-xl sm:text-2xl text-gold leading-snug" data-testid="about-philosophy-line">
            “Energy, fascia, and chakras are at the heart of my practice — encompassing the mind, body, and soul connection.”
          </p>
        </FadeUp>
        <div className="mt-8 space-y-6 text-mute text-base sm:text-lg leading-relaxed">
          <FadeUp>
            <p className="font-serif text-2xl sm:text-3xl text-ivory font-light leading-snug">
              “Where the pain is? It usually isn't the root of your problem.”
            </p>
          </FadeUp>
          <FadeUp>
            <p>
              Ariane has worked in wellness <span className="text-ivory">since 2007</span>, starting
              with reflexology and growing into a 2200-hour Registered Massage Therapist with a
              practice built on one conviction: the body is one intelligent, interconnected
              system — woven together by fascia, the connective web that links mind, body
              and soul.
            </p>
          </FadeUp>
          <FadeUp>
            <p>
              She has worked with athletes and artists backstage{" "}
              <span className="text-ivory">since 2013</span> — and for six years she was on the
              road touring full-time: tuning bodies up before showtime and bringing them down
              after, all under pressure, criss-crossing{" "}
              <span className="text-ivory">North America, Europe, Australia, South America and New
              Zealand</span>. Chair massage became her signature, and her favourite, for events
              and tournaments. That environment forged her specialty: helping bodies recover
              under demand — restore mobility, release tension, maintain performance when it
              matters.
            </p>
          </FadeUp>
          <FadeUp>
            <p>
              When COVID stopped the touring world, she stopped too — and walked through a deeply
              personal healing journey of her own. Today she continues her backstage work, carrying
              both sides of that story into every session.
            </p>
          </FadeUp>
          <FadeUp>
            <p>
              Her roots: <span className="text-ivory">Edmonton, Alberta and Montréal, Québec</span>.
              Today she is based in Montréal — and never limited to either city.
            </p>
          </FadeUp>
          <FadeUp>
            <p className="font-serif italic text-xl sm:text-2xl text-gold leading-snug">
              “My love? The fascia. The roadmap to everything stuck and unsaid.”
            </p>
          </FadeUp>
          <FadeUp>
            <p>
              A survivor of major car accidents, she understands compromised bodies from the inside.
              Her method is unconventional and results-driven — she doesn't just treat symptoms; she
              listens to the fascia, reads the system, and goes to the root.
            </p>
          </FadeUp>
          <FadeUp>
            <p className="text-ivory font-medium">
              This is wellness without the fluff. Hands-on, mind-tuned, soul-aligned.
            </p>
          </FadeUp>
        </div>

        <FadeUp delay={0.05} className="mt-12">
          <p className="eyebrow mb-6">Training &amp; credentials</p>
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3" data-testid="about-credentials">
            {CREDENTIALS.map((c) => (
              <li key={c} className="flex items-start gap-3 text-sm text-ivory/80 border-b border-white/5 pb-3">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-gold" aria-hidden="true" />
                {c}
              </li>
            ))}
          </ul>
        </FadeUp>
      </div>
    </div>
  </section>
);
